export const TAXONOMY_START = "TAXONOMY_START";
export const TAXONOMY_FAIL = "TAXONOMY_FAIL";
export const GET_TAXONOMY = "GET_TAXONOMY";
export const GET_TAXONOMY_SUCCESS = "GET_TAXONOMY_SUCCESS";
export const CREATE_TAXONOMY = "CREATE_TAXONOMY";
export const CREATE_TAXONOMY_SUCCESS = "CREATE_TAXONOMY_SUCCESS";
export const UPDATE_TAXONOMY = "UPDATE_TAXONOMY";
export const UPDATE_TAXONOMY_SUCCESS = "UPDATE_TAXONOMY_SUCCESS";
